module.exports = __webpack_public_path__ + "static/media/azul-seta.b57b1fbf.svg";